import { Injectable } from '@angular/core';
import { McticHttpClient, McticHttpParams, Page, Pageable } from '@mctic/ng-core';
import { Observable } from 'rxjs';
import { DispendioEquipamentoSoftware, ObjectValue } from '../shared/model';

@Injectable({
  providedIn: 'root'
})
export class DispendioEquipamentoSoftwareService {

  private readonly service = '/sepin-backend/rest/dispendios-equipamentos-softwares';
  private _paramIdProjeto: number;
  private _paramPathretorno: string;
  private _paramDispendioProprio: boolean;
  private _paginacaoDispendios: Page<DispendioEquipamentoSoftware> = new Page();
  private _pageable: Pageable = new Pageable({pageSize: 5});
  private _valorTotal: ObjectValue<number> = new ObjectValue();
  private _paramIndexRetorno: number;


  constructor(private readonly http: McticHttpClient) {
  }

  cadastrar(dispendio: DispendioEquipamentoSoftware) {
    dispendio.dispendioImportado = false;
    return this.http.post<DispendioEquipamentoSoftware>(this.service, dispendio);
  }

  alterar(dispendio: DispendioEquipamentoSoftware) {
    return this.http.put<DispendioEquipamentoSoftware>(this.service, dispendio);
  }

  excluir(id: number) {
    return this.http.delete(`${this.service}/${id}`);
  }

  obterTodos() {
    return this.http.get<Page<DispendioEquipamentoSoftware>>(`${this.service}/query`);
  }

  obterValorTotal(idProjeto: number, proprio?: boolean) {
    const dispendioProprio = proprio === undefined ? true : proprio;
    return this.http.get<ObjectValue<number>>(`${this.service}/${idProjeto}/valor-total/${dispendioProprio}`);
  }

  obterPorId(id: number): Observable<DispendioEquipamentoSoftware> {
    return this.http.get<DispendioEquipamentoSoftware>(`${this.service}/${id}`);
  }

  consultar() {
    const queryParams = new McticHttpParams()
      .setNumber('idProjeto', this.paramIdProjeto)
      .set('proprio', String(this.paramDispendioProprio))
      .setPageable(this.pageable);

    return this.http.get<Page<DispendioEquipamentoSoftware>>(`${this.service}/query`, {params: queryParams.toHttpParams()})
      .subscribe(
        response => {
          this.paginacaoDispendios = response;
        },
        () => {
          this.paginacaoDispendios = new Page();
          this.paginacaoDispendios.content = [];
        }
      );
  }

  salvarArquivoImportacao(file: File, idProjeto: number, proprio?: boolean) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    const dispendioProprio = proprio === undefined ? true : proprio;
    return this.http.post<any>(`${this.service}/${idProjeto}/upload/${dispendioProprio}`, formData);
  }

  set paramIdProjeto(value: number) {
    this._paramIdProjeto = value;
  }

  get paramIdProjeto(): number {
    return this._paramIdProjeto;
  }

  set paramDispendioProprio(value: boolean) {
    this._paramDispendioProprio = value;
  }

  get paramDispendioProprio(): boolean {
    return this._paramDispendioProprio;
  }

  set paramPathretorno(value: string) {
    this._paramPathretorno = value;
  }

  get paramPathretorno(): string {
    return this._paramPathretorno;
  }

  set paginacaoDispendios(value: Page<DispendioEquipamentoSoftware>) {
    this._paginacaoDispendios = value;
  }

  get paginacaoDispendios(): Page<DispendioEquipamentoSoftware> {
    return this._paginacaoDispendios;
  }

  set pageable(value: Pageable) {
    this._pageable = value;
  }

  get pageable(): Pageable {
    return this._pageable;
  }

  set valorTotal(value: ObjectValue<number>) {
    this._valorTotal = value;
  }

  get valorTotal(): ObjectValue<number> {
    return this._valorTotal;
  }

  set paramIndexRetorno(value: number) {
      this._paramIndexRetorno = value;
  }

  get paramIndexRetorno(): number {
      return this._paramIndexRetorno;
  }

}
